import React from 'react';
import { Play, ArrowDown } from 'lucide-react';
interface SecretWelcomeSectionProps {
  onStart: () => void;
}
export function SecretWelcomeSection({
  onStart
}: SecretWelcomeSectionProps) {
  return <section className="relative w-full min-h-[90vh] flex flex-col items-center justify-center py-20 px-4 bg-[#0C0A09] overflow-hidden" data-id="element-352">
      {/* Ambient Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl opacity-20 pointer-events-none" data-id="element-353">
        <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] rounded-full bg-[#C89B40] blur-[120px]" data-id="element-354" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full bg-[#CFA86A] blur-[100px]" data-id="element-355" />
      </div>

      <div className="relative z-10 max-w-4xl w-full mx-auto text-center space-y-12" data-id="element-356">
        {/* Header Group */}
        <div className="space-y-6 animate-fade-in-up" data-id="element-357">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-wide text-[#F5EDE0] font-serif" data-id="element-358">
            Bienvenido a tu{' '}
            <span className="text-[#C89B40] italic" data-id="element-359">Espacio de Claridad</span>
          </h1>
          <p className="text-[#d9cec0]/80 text-lg md:text-xl font-light tracking-wide max-w-2xl mx-auto" data-id="element-360">
            Antes de comenzar, te invitamos a conectar con este mensaje de
            bienvenida.
          </p>
        </div>

        {/* Video Container */}
        <div className="relative w-full max-w-3xl mx-auto aspect-video rounded-xl overflow-hidden shadow-2xl ring-1 ring-[#C89B40]/20 group cursor-pointer bg-[#151210]" data-id="element-361">
          {/* Placeholder for actual video embed */}
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#1a1614] to-[#0C0A09]" data-id="element-362">
            <div className="relative flex items-center justify-center w-20 h-20 rounded-full border border-[#C89B40]/30 bg-[#C89B40]/10 backdrop-blur-sm transition-all duration-500 group-hover:scale-110 group-hover:bg-[#C89B40]/20" data-id="element-363">
              <Play className="w-8 h-8 text-[#C89B40] ml-1" fill="currentColor" data-id="element-364" />
            </div>
            <p className="absolute bottom-8 text-[#d9cec0]/40 text-sm tracking-widest uppercase" data-id="element-365">
              Video de Introducción
            </p>
          </div>

          {/* If a real video URL exists, replace the above div with:
           <iframe
           src="YOUR_VIDEO_URL"
           className="w-full h-full"
           allow="autoplay; fullscreen"
           />
           */}
        </div>

        {/* Text & CTA */}
        <div className="max-w-2xl mx-auto space-y-8" data-id="element-366">
          <p className="text-[#d9cec0]/90 text-base md:text-lg leading-relaxed font-light" data-id="element-367">
            Estás a punto de realizar el{' '}
            <strong className="text-[#C89B40] font-normal" data-id="element-368">
              Test de Arquetipos Decisor
            </strong>
            . Para obtener un resultado real, necesitamos tu honestidad radical
            y tu intuición. No pienses demasiado las respuestas; deja que tu
            verdad emerja.
          </p>

          <button onClick={onStart} className="group relative inline-flex items-center gap-3 px-8 py-4 bg-[#C89B40] text-[#0C0A09] rounded-full text-sm font-semibold tracking-widest uppercase transition-all duration-300 hover:bg-[#d4a855] hover:shadow-[0_0_20px_rgba(200,155,64,0.3)] hover:-translate-y-0.5" data-id="element-369">
            <span data-id="element-370">Empezar el test</span>
            <ArrowDown className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-1" data-id="element-371" />
          </button>
        </div>
      </div>
    </section>;
}